import { useQuery } from '@tanstack/react-query';

import { fetchCatalog } from '@/services/collections';
import type { UpcomingCollection } from '@/types/collection';

import { CATALOG_QUERY_KEY } from './useCollections';

const NONE: UpcomingCollection[] = [];

/** Анонсы «Скоро». Тот же запрос и кэш, что у каталога. */
export function useUpcomingCollections(): UpcomingCollection[] {
  const { data } = useQuery({
    queryKey: CATALOG_QUERY_KEY,
    queryFn: fetchCatalog,
    staleTime: 5 * 60_000,
    select: (catalog) => catalog.upcoming,
  });

  return data ?? NONE;
}
